import React from 'react';
import { ThemeProvider } from 'styled-components';

var Provider = function Provider(_ref) {
  var children = _ref.children,
      columns = _ref.columns,
      breakpoints = _ref.breakpoints;
  return React.createElement(ThemeProvider, {
    theme: {
      griding: {
        columns: columns,
        breakpoints: breakpoints
      }
    }
  }, children);
};

Provider.defaultProps = {
  columns: 12,
  breakpoints: {
    xs: {
      width: 0,
      gutter: 16
    },
    sm: {
      width: 480,
      gutter: 24
    },
    md: {
      width: 768,
      gutter: 32
    },
    lg: {
      width: 992
    },
    xg: {
      width: 1280
    }
  }
};
export default Provider;